import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import InputSuffixShrink from './InputSuffixShrink';
import ClientProvider from './client';
export default createDemo(import.meta.url, InputSuffixShrink, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/text-fields/demos/input-suffix-shrink/InputSuffixShrink.tsx",
    "fileName": "InputSuffixShrink.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport { filledInputClasses } from '@mui/material/FilledInput';\nimport { inputBaseClasses } from '@mui/material/InputBase';\nimport TextField from '@mui/material/TextField';\nimport InputAdornment from '@mui/material/InputAdornment';\n\nexport default function InputSuffixShrink() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <TextField\n        id=\"outlined-suffix-shrink\"\n        label=\"Outlined\"\n        variant=\"outlined\"\n        slotProps={{\n          input: {\n            endAdornment: (\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  opacity: 0,\n                  pointerEvents: 'none',\n                  [`[data-shrink=true] ~ .${inputBaseClasses.root} > &`]: {\n                    opacity: 1,\n                  },\n                }}\n              >\n                lbs\n              </InputAdornment>\n            ),\n          },\n        }}\n      />\n      <TextField\n        id=\"filled-suffix-shrink\"\n        label=\"Filled\"\n        variant=\"filled\"\n        slotProps={{\n          input: {\n            endAdornment: (\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  alignSelf: 'flex-end',\n                  opacity: 0,\n                  pointerEvents: 'none',\n                  [`.${filledInputClasses.root} &`]: {\n                    marginBottom: '7.5px',\n                  },\n                  [`[data-shrink=true] ~ .${inputBaseClasses.root} > &`]: {\n                    opacity: 1,\n                  },\n                }}\n              >\n                days\n              </InputAdornment>\n            ),\n          },\n        }}\n      />\n      <TextField\n        id=\"standard-suffix-shrink\"\n        label=\"Standard\"\n        variant=\"standard\"\n        slotProps={{\n          htmlInput: {\n            sx: { textAlign: 'right' },\n          },\n          input: {\n            endAdornment: (\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  alignSelf: 'flex-end',\n                  margin: 0,\n                  marginBottom: '5px',\n                  opacity: 0,\n                  pointerEvents: 'none',\n                  [`[data-shrink=true] ~ .${inputBaseClasses.root} > &`]: {\n                    opacity: 1,\n                  },\n                }}\n              >\n                @gmail.com\n              </InputAdornment>\n            ),\n          },\n        }}\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 96,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport { filledInputClasses } from '@mui/material/FilledInput';\nimport { inputBaseClasses } from '@mui/material/InputBase';\nimport TextField from '@mui/material/TextField';\nimport InputAdornment from '@mui/material/InputAdornment';\n\nexport default function InputSuffixShrink() {\n  return (\n    <Box\n      component=\"form\"\n      sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}\n      noValidate\n      autoComplete=\"off\"\n    >\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <TextField\n        id=\"outlined-suffix-shrink\"\n        label=\"Outlined\"\n        variant=\"outlined\"\n        slotProps={{\n          input: {\n            endAdornment: (\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  opacity: 0,\n                  pointerEvents: 'none',\n                  [`[data-shrink=true] ~ .${inputBaseClasses.root} > &`]: {\n                    opacity: 1,\n                  },\n                }}\n              >\n                lbs\n              </InputAdornment>\n            ),\n          },\n        }}\n      />\n      <TextField\n        id=\"filled-suffix-shrink\"\n        label=\"Filled\"\n        variant=\"filled\"\n        slotProps={{\n          input: {\n            endAdornment: (\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  alignSelf: 'flex-end',\n                  opacity: 0,\n                  pointerEvents: 'none',\n                  [`.${filledInputClasses.root} &`]: {\n                    marginBottom: '7.5px',\n                  },\n                  [`[data-shrink=true] ~ .${inputBaseClasses.root} > &`]: {\n                    opacity: 1,\n                  },\n                }}\n              >\n                days\n              </InputAdornment>\n            ),\n          },\n        }}\n      />\n      <TextField\n        id=\"standard-suffix-shrink\"\n        label=\"Standard\"\n        variant=\"standard\"\n        slotProps={{\n          htmlInput: {\n            sx: { textAlign: 'right' },\n          },\n          input: {\n            endAdornment: (\n              <InputAdornment\n                position=\"end\"\n                sx={{\n                  alignSelf: 'flex-end',\n                  margin: 0,\n                  marginBottom: '5px',\n                  opacity: 0,\n                  pointerEvents: 'none',\n                  [`[data-shrink=true] ~ .${inputBaseClasses.root} > &`]: {\n                    opacity: 1,\n                  },\n                }}\n              >\n                @gmail.com\n              </InputAdornment>\n            ),\n          },\n        }}\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 96,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/FilledInput",
      "@mui/material/InputBase",
      "@mui/material/TextField",
      "@mui/material/InputAdornment"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
